module.exports = __webpack_public_path__ + "img/bg_download_app.51f99fa9.png";